import { createContext, useContext, type ReactNode } from "react";
import { useTwilioVoice, type UseTwilioVoice } from "@hooks/useTwilioVoice";

const VoiceContext = createContext<UseTwilioVoice | null>(null);

export function VoiceProvider({ children }: { children: ReactNode }) {
  const voice = useTwilioVoice();
  return <VoiceContext.Provider value={voice}>{children}</VoiceContext.Provider>;
}

export function useVoice(): UseTwilioVoice {
  const ctx = useContext(VoiceContext);
  if (!ctx) throw new Error("useVoice must be used within VoiceProvider");
  return ctx;
}